import { Component, ViewChild, ElementRef, Input, forwardRef, Directive, HostListener  } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

const /** @type {?} */ noop = () => { };

const /** @type {?} */ masks = [
	'(1',
    '(11',
    '(11) 1',
    '(11) 11',
    '(11) 111',
    '(11) 1111',
    '(11) 1111-1',
    '(11) 1111-11',
    '(11) 1111-111',
    '(11) 1111-1111',
    '(11) 11111-1111'
];

const /** @type {?} */ clean = (number) => {
	return number
		.toString()
		.replace(/[^\d\^]/gm, '');
}

const /** @type {?} */ format = (number) => {
	let /** @type {?} */ lastCharIndex = 0;
	const /** @type {?} */ cleanValue = clean(number);
	const /** @type {?} */ charCount = cleanValue.replace(/\^/gm, '').length;
	if (charCount === 0) {
		return {
			formatted: '',
			cursorPosition: 0
		};
	}
	const /** @type {?} */ mask = masks[charCount - 1];
	if (charCount > 1 && !mask) {
		return null;
	}
	let /** @type {?} */ cursorPosition;
	const /** @type {?} */ formatted = mask.split('').map((c, i) => {
		if (c === '1') {
			if (cleanValue[lastCharIndex] == '^') {
				cursorPosition = i + 1;
				lastCharIndex++;
			}

			lastCharIndex++;
			return cleanValue[lastCharIndex - 1];
		} else {
			return c;
		}
	}).join('');

	if (!cursorPosition) {
		cursorPosition = formatted.length;
	}

	cursorPosition++; // because of '+'

	return {
		formatted: `${formatted}`,
		cursorPosition
	}
}
export class NgxPhoneMaskBrDirective {
private onTouchedCallback: () => void = noop;
private onChangeCallback: (_: any) => void = noop;
public valueType: 'clean' | 'full' = 'clean';
public showMask: boolean = true;
public disabled;
private _value;
private oldValue = '';
/**
 * @param {?} input
 */
constructor(private input: ElementRef) {
	}
/**
 * @return {?}
 */
updateInputView() {
		const /** @type {?} */ input = this.input.nativeElement;
		const /** @type {?} */ cursorPosition = input.selectionStart;
		const /** @type {?} */ value = this._value;
		const /** @type {?} */ valueWithCursor = value.substring(0, cursorPosition) + '^' + value.substring(cursorPosition);

		const /** @type {?} */ formatted = format(valueWithCursor);
		
		if (value === '') {
			return;
		}

		if (!formatted) {
			input.value = this.oldValue;
			return;
		}

		const /** @type {?} */ newValue = formatted.formatted;
		if (newValue != input.value) {
			input.value = newValue;
			input.setSelectionRange(formatted.cursorPosition, formatted.cursorPosition);
		}
		this.oldValue = newValue;
		this.emitValue(newValue);
	}
/**
 * @param {?} v
 * @return {?}
 */
emitValue(v) {
		let /** @type {?} */ value;
		switch(this.valueType) {
			case 'clean':
				value = v.replace(/[^\d\+]/gm, '');
				break;
			case 'full':
				value = v;
				break;
		}
		this.onChangeCallback(value);
	}
/**
 * @return {?}
 */
onInput() {
		this._value = this.input.nativeElement.value;
		this.updateInputView();
	}
/**
 * @param {?} v
 * @return {?}
 */
set value(v) {
		let /** @type {?} */ value = v ? v : '';
		this._value = value;
		this.updateInputView();
	}
/**
 * @param {?} value
 * @return {?}
 */
writeValue(value: any) {
		this.value = value;
	}
/**
 * @param {?} fn
 * @return {?}
 */
registerOnChange(fn: any) {
		this.onChangeCallback = fn;
	}
/**
 * @param {?} fn
 * @return {?}
 */
registerOnTouched(fn: any) {
		this.onTouchedCallback = fn;
	}
/**
 * @param {?} isDisabled
 * @return {?}
 */
setDisabledState(isDisabled) {
		this.disabled = isDisabled;
	}
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
	selector: '[ngxPhoneMaskBr]',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => NgxPhoneMaskBrDirective),
			multi: true
		}
	]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'valueType': [{ type: Input },],
'showMask': [{ type: Input },],
'onInput': [{ type: HostListener, args: ['input', ] },],
};
}

function NgxPhoneMaskBrDirective_tsickle_Closure_declarations() {
/** @type {?} */
NgxPhoneMaskBrDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgxPhoneMaskBrDirective.ctorParameters;
/** @type {?} */
NgxPhoneMaskBrDirective.propDecorators;
/** @type {?} */
NgxPhoneMaskBrDirective.prototype.onTouchedCallback;
/** @type {?} */
NgxPhoneMaskBrDirective.prototype.onChangeCallback;
/** @type {?} */
NgxPhoneMaskBrDirective.prototype.valueType;
/** @type {?} */
NgxPhoneMaskBrDirective.prototype.showMask;
/** @type {?} */
NgxPhoneMaskBrDirective.prototype.disabled;
/** @type {?} */
NgxPhoneMaskBrDirective.prototype._value;
/** @type {?} */
NgxPhoneMaskBrDirective.prototype.oldValue;
/** @type {?} */
NgxPhoneMaskBrDirective.prototype.input;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
